import React from "react";
import { AuthProvider } from "./pages/AuthContext";
import { PopupProvider } from "./components/PopupProvider";
import RouteConfig from "./routes";

function App() {
  return (
    <div className="app">
      <PopupProvider>
        <AuthProvider>
          <RouteConfig />
        </AuthProvider>
      </PopupProvider>
    </div>
  );
}

export default App;
